import { FC } from 'react';

const Step3Icon: FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      version="1.1"
      id="Capa_2_00000161625598580452922670000009065002035151643028_"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      height={100}
      xmlSpace="preserve"
      fill={color}
    >
      <g>
        <path
          fill={color}
          d="M650.3,855.8H349.7c-104.6,0-189.6-85.1-189.6-189.6c0-8.3,6.7-15,15-15s15,6.7,15,15c0,88,71.6,159.6,159.6,159.6h300.6
		c88,0,159.6-71.6,159.6-159.6c0-8.3,6.7-15,15-15s15,6.7,15,15C839.9,770.7,754.8,855.8,650.3,855.8z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M869.6,679.9H130.3c-8.2,0-14.8-6.6-14.8-14.8s6.6-14.8,14.8-14.8h739.3c8.2,0,14.8,6.6,14.8,14.8S877.8,679.9,869.6,679.9
		z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M802.2,614.2c-8.3,0-15-6.7-15-15c0-83.8-68.2-152-152-152c-83.8,0-152,68.2-152,152c0,8.3-6.7,15-15,15s-15-6.7-15-15
		c0-100.3,81.6-182,182-182c100.3,0,182,81.6,182,182C817.2,607.5,810.5,614.2,802.2,614.2z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M700.1,614.2c-8.3,0-15-6.7-15-15c0-27.5-22.4-49.8-49.8-49.8s-49.8,22.4-49.8,49.8c0,8.3-6.7,15-15,15s-15-6.7-15-15
		c0-44,35.8-79.8,79.8-79.8s79.8,35.8,79.8,79.8C715.1,607.5,708.3,614.2,700.1,614.2z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M198.6,614.2c-8.3,0-15-6.7-15-15c0-100.3,81.6-182,182-182c29,0,57.8,7,83.4,20.2c24.8,12.8,46.6,31.4,63.2,53.9
		c4.9,6.7,3.5,16.1-3.2,21c-6.7,4.9-16.1,3.5-21-3.2c-28.6-38.8-74.3-61.9-122.4-61.9c-83.8,0-152,68.2-152,152
		C213.6,607.5,206.9,614.2,198.6,614.2z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M300.7,614.2c-8.3,0-15-6.7-15-15c0-44,35.8-79.8,79.8-79.8c8.3,0,15,6.7,15,15s-6.7,15-15,15c-27.5,0-49.8,22.4-49.8,49.8
		C315.7,607.5,309,614.2,300.7,614.2z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M712.3,458.3c-2.6,0-5.3-0.7-7.6-2.1c-7-4.2-9.2-13.3-5-20.3l113.2-187.4c6.9-11.4,8.6-24.7,4.9-37.5
		c-3.8-12.8-12.4-23.1-24.4-29c-11.9-5.8-25.3-6.4-37.6-1.7c-12.4,4.8-21.9,14.2-26.8,26.5l-89.6,224.9c-3,7.6-11.6,11.3-19.2,8.3
		c-7.6-3-11.3-11.6-8.3-19.2l89.6-224.9c7.9-19.8,23.8-35.5,43.7-43.2c19.9-7.6,42.2-6.6,61.3,2.7c19.2,9.5,33.7,26.7,39.7,47.2
		c6,20.6,3.1,42.9-8,61.2L725,451.1C722.2,455.7,717.3,458.3,712.3,458.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M477.6,263.5c23.5,30,24.3,71,23.1,90.2c-0.4,6-5.8,10.3-11.7,9.2c-18.9-3.5-58.5-14.1-82-44.2c-23.5-30-24.3-71-23.1-90.2
		c0.4-6,5.8-10.3,11.7-9.2C414.5,222.9,454.1,233.5,477.6,263.5z"
        />
      </g>
    </svg>
  );
};

export default Step3Icon;
